import { Stack, Typography } from '@mui/material';
import { MUITable } from 'components/shared/MUITable';
import { AssistantLogRow } from './types';
import { createTableColumns } from './tableConfig';

interface Props {
  rows: AssistantLogRow[];
  isLoading: boolean;
  onViewDetails: (row: AssistantLogRow) => void;
}

export const AssistantLogTable = ({ rows, isLoading, onViewDetails }: Props) => {
  const columns = createTableColumns(onViewDetails);

  if (!isLoading && !rows.length) {
    return (
      <Typography color="text.secondary" sx={{ mt: 2 }}>
        No activity records found for the selected period.
      </Typography>
    );
  }

  return (
    <Stack flex={1} overflow="hidden">
      <MUITable<AssistantLogRow> stickyHeader hover isLoading={isLoading} tableData={rows} columns={columns} />
    </Stack>
  );
};
